import { UserName } from 'features/users/types';

export const searchByName = (name: UserName, searchQuery: string) => {
  if (!name) {
    return false;
  }

  return name.toLowerCase().includes(searchQuery);
};
